export enum RequestStatus {
	Pending = 1,
	Fulfilled,
	Rejected,
	Idle,
}
